import React from "react";

function GovIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <g clip-path="url(#clip0_2377_9769)">
        <path
          d="M6.56485 0.864844C6.83282 0.711719 7.16368 0.711719 7.43438 0.864844L12.132 3.54727L12.2496 3.59375V3.61836L13.5594 4.36758C13.9039 4.56445 14.0734 4.96914 13.9723 5.35195C13.8711 5.73477 13.5238 6.00273 13.1274 6.00273H0.874618C0.478134 6.00273 0.130868 5.73477 0.0296966 5.35195C-0.0714753 4.96914 0.098056 4.56445 0.442587 4.36758L1.74962 3.61836V3.59375L1.86993 3.55L6.56485 0.864844ZM1.74962 6.875H3.49962V12.125H4.59337V6.875H6.34337V12.125H7.65587V6.875H9.40587V12.125H10.4996V6.875H12.2496V12.2426C12.266 12.2508 12.2824 12.2617 12.2988 12.2727L13.6113 13.1477C13.9313 13.3609 14.0762 13.7602 13.9641 14.1293C13.852 14.4984 13.5102 14.75 13.1246 14.75H0.874618C0.489072 14.75 0.150009 14.4984 0.0378997 14.1293C-0.0742096 13.7602 0.0679779 13.3609 0.390634 13.1477L1.70313 12.2727C1.71954 12.2617 1.73595 12.2535 1.75235 12.2426V6.875H1.74962Z"
          fill="#BFDBFE"
        />
      </g>
      <defs>
        <clipPath id="clip0_2377_9769">
          <path d="M0 0.75H14V14.75H0V0.75Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default GovIcon;
